import { render, staticRenderFns } from "./ShiftAssignmentTable.vue?vue&type=template&id=28087ca2"
import script from "./ShiftAssignmentTable.vue?vue&type=script&lang=js"
export * from "./ShiftAssignmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28087ca2')) {
      api.createRecord('28087ca2', component.options)
    } else {
      api.reload('28087ca2', component.options)
    }
    module.hot.accept("./ShiftAssignmentTable.vue?vue&type=template&id=28087ca2", function () {
      api.rerender('28087ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/settings/components/tables/ShiftAssignmentTable.vue"
export default component.exports